import UserMessageAuthorName from "%/dynamic-component-editor/standard-components/user-message/UserMessageAuthorName.vue";
import UserMessageCreated from "%/dynamic-component-editor/standard-components/user-message/UserMessageCreated.vue";
import UserMessageBody from "%/dynamic-component-editor/standard-components/user-message/UserMessageBody.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyUserMessage extends LegacyEntity {
  get elements() {
    return {
      UserMessageAuthorName,
      UserMessageCreated,
      UserMessageBody,
    };
  }
}
